<oui-tab-group
  class="activite-tabs"
  [selectedIndex]="selectedTabIndex()"
  (selectedIndexChange)="selectedTabIndex.set($event)">
  <oui-tab label="Par date">
    <ng-container
      [ngTemplateOutlet]="activityContent"
      [ngTemplateOutletContext]="{
        groups: dateGroups(),
      }"></ng-container>
  </oui-tab>
  <oui-tab label="Par habilitation">
    <ng-container
      [ngTemplateOutlet]="activityContent"
      [ngTemplateOutletContext]="{
        groups: habilitationGroups(),
      }"></ng-container>
  </oui-tab>
</oui-tab-group>

<ng-template #activityContent let-groups="groups">
  @if (isLoading()) {
    <div class="activity-state" aria-live="polite">
      <oui-loading></oui-loading>
    </div>
  } @else if (hasError() && items().length === 0) {
    <div class="activity-state activity-state--error" role="alert">
      <p>Une erreur est survenue durant la récupération de l'activité.</p>
      <oui-button type="outlined" color="primary" (click)="loadFirstPage()">
        Réessayer
      </oui-button>
    </div>
  } @else if (items().length === 0) {
    <p class="activity-state">
      Aucune activité d'habilitation n'a encore été enregistrée.
    </p>
  } @else {
    <div class="activity-groups">
      @for (group of groups; track group.key) {
        <section class="activity-group oui-elevation-04">
          <header class="activity-group__header">
            <h3 class="activity-group__title">
              {{ group.label }}
            </h3>
          </header>

          <ul class="activity-list">
            @for (item of group.items; track item.id) {
              <li class="activity-entry">
                <span
                  class="activity-entry__icon"
                  [style.backgroundColor]="item.backgroundColor"
                  [style.color]="item.iconColor"
                  aria-hidden="true">
                  <oui-icon>{{ item.icon }}</oui-icon>
                </span>
                <span class="activity-entry__content">
                  <span class="activity-entry__actor caption-bold">{{
                    item.actorName
                  }}</span>
                  <span
                    class="activity-entry__label subtitle-2"
                    [style.color]="item.labelColor">
                    {{ item.actionLabel }}
                  </span>
                  <span class="activity-entry__date body-2">{{
                    item.formattedDateTime
                  }}</span>
                </span>
              </li>
            }
          </ul>
        </section>
      }
    </div>

    @if (hasError()) {
      <p class="activity-load-error" role="alert">
        Une erreur est survenue durant le chargement des actions suivantes.
      </p>
    }

    @if (hasNextPage()) {
      <div class="activity-more">
        <oui-button
          type="outlined"
          color="primary"
          [disabled]="isLoadingMore()"
          (click)="loadMore()">
          Voir plus
        </oui-button>
      </div>
    }
  }
</ng-template>
